var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "-4 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "at") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.375 8.688h1.656s-1.219 6.906-1.844 10.375c-0.531 3 3.375 0.438 4.531-0.906 1.125-1.281 3.688-6.969-0.844-11.5-4.094-4.063-10.281-2.938-12.969-1.375-3.156 1.844-6 6.156-5.063 11.125 1.031 5.563 4.938 8.094 7.281 8.688 5.094 1.281 8.438 0.063 11.625-3.219 0.531 0 1-0.031 1.625-0.031-2.156 3.281-5.813 5.063-8.875 5.125-2.688 0.031-5.969-0.063-9.344-3.188-3.406-3.156-4.531-7.875-3.438-12.156 1.094-4.25 4.313-7.719 8.719-8.781s10.219 0.063 13.156 5.25c2.5 4.406 0.438 8.969-1.188 10.781-2.5 2.813-7.719 5.094-6.969 0.938 0.031-0.156 0.063-0.375 0.094-0.563-1.219 1.125-2.75 1.844-4.344 1.844-3.156 0-5.5-2.75-4.969-6.156s3.781-6.156 6.938-6.156c1.656 0 3 0.781 3.875 2 0.219-1.25 0.344-2.094 0.344-2.094zM10.375 19.563c1.969 0 3.875-1.438 4.688-3.406 0.156-0.75 0.313-1.531 0.438-2.313-0.125-2.063-1.563-3.531-3.625-3.531-2.375 0-4.188 2.063-4.594 4.625s0.719 4.625 3.094 4.625z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAt);
export default __webpack_public_path__ + "static/media/at.bbbb67692c5830c3ddbba5cd9f3626c9.svg";
export { ForwardRef as ReactComponent };